<template>
	<div class="promotion-detail">
        <div class="title">{{ detail.title }}</div>
         <div class="time">
            <span class="sub-title">活动时间</span>
            <span class="sub-title date">{{ formatTime(detail.beginTime) }} - {{ formatTime(detail.endTime) }}</span>
         </div>
        <div v-html="detail.content" class="content"></div>
	</div>
</template>

<script>
import ajax from '@/api/ajax'
export default {
    name: 'promotionDetail',
    data() {
        return {
            detail: []
        }
    },
    created() {
		ajax.getPromotions({
			params:{
                id: this.$route.query.id
		}}).then(res => {
			this.detail = res && res[0] || {}
		})
	},
    methods: {
        formatTime(time) {
            if(!time) return time
            return time.replace(/-/ig, '.')
        },
        goDetail(detail) {
            this.$router.push({
                path: 'detail',
                query: {
                    id: detail.id
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.promotion-detail {
    .title {
        background-color: #808080;
        padding: .2rem;
        font-size: .3rem;
        color: #fff;
        text-align: center;
    }
    .time {
        padding: .2rem;
        border-bottom: #999 1px dashed;
        background-color: #fff;
        font-size: .28rem;
        color: #333;
        text-align: center;
    }
    .content {
        padding: .2rem;
        >>> img {
            max-width: 100%;
            height: auto;
        }
        >>> .image {
            text-align: center;
            margin: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/promotion/detail.vue